import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import { productTypeListPC, getProductList as _getProductList, sizeList, productNaturePrice, addCart } from '@/services/http';
import { readCookie } from '@/tools/tools';
import SKU from '@/common/sku.vue';
import { Action, State } from 'vuex-class';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 分类列表
    _this.productTypeList = [];
    // 分类列表子分类
    _this.productTypeChildren = [];
    _this.status = false;
    _this.debounceTimer = null;
    _this.Timer = null;
    _this.parentTypeId = '';
    // 导航第一个分类id
    _this.firstProductId = '';
    _this.currentIndex = 0;
    _this.currentSubIndex = 0;
    _this.printerModel = '';
    _this.pageNo = 1;
    _this.pageSize = 10;
    _this.recommendList = [];
    _this.loading = false;
    _this.objData = {};
    _this.totalPages = 1;
    _this.disabled = false;
    _this.dataList = [];
    _this.FilePathPcimg = '';
    _this.token = '';
    _this.arrList = [];
    _this.activeIndex = '全部';
    _this.sizeStauts = false;
    _this.clickFlag = 0; // 商品列表添加刷新点击标识刷新0，点击1
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "onPrinterModelChange",
    value: function () {
      var _onPrinterModelChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(newModel, oldModel) {
        var _newModel$printerMode;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 检查 newModel 是否真的存在且有变化，避免不必要的请求
              // if (newModel && newModel.printerModel) {
              // 当 state 变化时，调用 handData 方法重新获取尺寸列表
              this.printerModel = (newModel === null || newModel === void 0 || (_newModel$printerMode = newModel.printerModel) === null || _newModel$printerMode === void 0 ? void 0 : _newModel$printerMode.printerModel) || '';
              this.recommendList = [];
              _context.next = 4;
              return this.getProductTypeList();
            case 4:
              _context.next = 6;
              return this.handSize();
            case 6:
              this.currentIndex = 0;
              this.currentSubIndex = 0;
              // }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onPrinterModelChange(_x, _x2) {
        return _onPrinterModelChange.apply(this, arguments);
      }
      return onPrinterModelChange;
    }()
  }, {
    key: "created",
    value: function created() {
      this.token = readCookie('accessToken') || '';
      this.disabled = true;
      this.clickFlag = 0;
      // this.getProductTypeList()
    }
  }, {
    key: "handSize",
    value: function () {
      var _handSize = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return sizeList({
                productTypeId: this.firstProductId ? this.firstProductId : this.parentTypeId,
                productParentTypeId: this.parentTypeId,
                printerModel: this.printerModel
              }).then(function (res) {
                _this2.arrList = res.data.data;
                _this2.arrList.unshift('全部');
                _this2.activeIndex = '全部';
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handSize() {
        return _handSize.apply(this, arguments);
      }
      return handSize;
    }() // 浏览更多
  }, {
    key: "watchMore",
    value: function watchMore(id) {
      this.$router.push("/classify?parentTypeId=".concat(id));
    }
  }, {
    key: "goDetails",
    value: function goDetails(list) {
      if (list.productSku) {
        this.$router.push("/details?id=".concat(list.id, "&productPriceId=").concat(list.natureIds, "&from=hotlist&PriceIds=").concat(list.productPriceId));
      } else {
        this.$router.push("/details?id=".concat(list.id, "&from=hotlist&PriceIds=").concat(list.productPriceId));
      }
      sessionStorage.setItem('detailsList', JSON.stringify(list));
    }
    // 选择分类
  }, {
    key: "selectMenu",
    value: function () {
      var _selectMenu = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(productTypeId, index) {
        var _this$productTypeList,
          _this3 = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.currentIndex = index;
              this.currentSubIndex = 0;
              this.pageNo = 1;
              this.totalPages = 1;
              this.disabled = false;
              this.recommendList = [];
              this.clickFlag = 0;
              this.parentTypeId = productTypeId;
              this.firstProductId = (_this$productTypeList = this.productTypeList[this.currentIndex]) === null || _this$productTypeList === void 0 || (_this$productTypeList = _this$productTypeList.children[0]) === null || _this$productTypeList === void 0 ? void 0 : _this$productTypeList.id;
              if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
              }
              this.debounceTimer = window.setTimeout(function () {
                _this3.getProductList();
                _this3.handChangId();
                _this3.handSize();
              }, 1000);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function selectMenu(_x3, _x4) {
        return _selectMenu.apply(this, arguments);
      }
      return selectMenu;
    }() // 选择二级分类
  }, {
    key: "selectSubMenu",
    value: function () {
      var _selectSubMenu = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(productTypeId, index) {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.pageNo = 1;
              this.totalPages = 1;
              this.clickFlag = 1;
              this.currentSubIndex = index;
              // this.parentTypeId = ''
              this.firstProductId = productTypeId;
              this.disabled = false;
              this.recommendList = [];
              if (this.Timer) {
                clearTimeout(this.Timer);
              }
              this.Timer = window.setTimeout(function () {
                _this4.handChangId();
                _this4.handSize();
                _this4.getProductList();
              }, 1000);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function selectSubMenu(_x5, _x6) {
        return _selectSubMenu.apply(this, arguments);
      }
      return selectSubMenu;
    }()
  }, {
    key: "getProductTypeList",
    value: function () {
      var _getProductTypeList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, _res$data$data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return productTypeListPC({
                companyId: 1,
                printerModel: this.printerModel
              });
            case 2:
              res = _context5.sent;
              if (res.data.code === 100) {
                this.productTypeList = res.data.data;
                this.parentTypeId = res.data.data.length !== 0 ? res.data.data[0].id : '';
                this.firstProductId = ((_res$data$data = res.data.data) === null || _res$data$data === void 0 || (_res$data$data = _res$data$data[0]) === null || _res$data$data === void 0 || (_res$data$data = _res$data$data.children) === null || _res$data$data === void 0 || (_res$data$data = _res$data$data[0]) === null || _res$data$data === void 0 ? void 0 : _res$data$data.id) || '';
                this.handChangId();
                this.getProductList();
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getProductTypeList() {
        return _getProductTypeList.apply(this, arguments);
      }
      return getProductTypeList;
    }() //切换分类id
  }, {
    key: "handChangId",
    value: function handChangId() {
      var obj = {
        productTypeId: this.firstProductId,
        parentTypeId: this.parentTypeId
      };
      // this.$emit('handTypeId', obj)
    }
  }, {
    key: "handOverall",
    value: function handOverall() {
      this.sizeStauts = !this.sizeStauts;
    }
  }, {
    key: "handChat",
    value: function handChat(item) {
      var _this5 = this;
      this.FilePathPcimg = item.listImagePath.cdnFilePathPc;
      var anchor = readCookie('anchor');
      productNaturePrice({
        productId: item.id,
        companyId: 1
      }).then(function (res) {
        if (res.data.code == 100 && res.data.data.nature[0].data.length > 1) {
          var _res$data$data2, _res$data$data3;
          _this5.objData = {
            FilePathPcimg: _this5.FilePathPcimg,
            pricelist: (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.price,
            selectarr: ((_res$data$data3 = res.data.data) === null || _res$data$data3 === void 0 || (_res$data$data3 = _res$data$data3.nature) === null || _res$data$data3 === void 0 || (_res$data$data3 = _res$data$data3[0]) === null || _res$data$data3 === void 0 ? void 0 : _res$data$data3.data) || []
          };
          _this5.$refs.skuRefs.handSku(_this5.objData);
          return;
        }
        addCart({
          productPriceId: item.productPriceId,
          num: 1,
          equip: anchor ? anchor.equip : '',
          version: anchor ? anchor.version : '',
          companyId: 1
        }).then(function (res) {
          if (res.data.code == 100) _this5.$message.success('加入购物车成功');
          _this5.setCardNum();
          _this5.setWhiteStauts();
        });
      });
    }
  }, {
    key: "handClick",
    value: function handClick(index) {
      this.activeIndex = index;
      this.recommendList = [];
      this.getProductList();
      this.sizeStauts = false;
    }
  }, {
    key: "onInfinite",
    value: function onInfinite() {
      if (!this.disabled && !this.status) {
        this.pageNo += 1;
        this.getProductList();
      }
    }
    // 获取商品分页列表
  }, {
    key: "getProductList",
    value: function () {
      var _getProductList2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var anchor, res, _res$data, _res$data$data4;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.loading) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              //  this.recommendList = []
              this.loading = true;
              this.status = true;
              anchor = readCookie('anchor');
              _context6.next = 7;
              return _getProductList({
                keyword: '',
                productTypeId: this.firstProductId,
                parentTypeId: this.parentTypeId,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                model: anchor ? anchor.model : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                clickFlag: this.clickFlag,
                companyId: 1,
                printerModel: this.printerModel,
                size: this.activeIndex == '全部' ? '' : this.activeIndex
              });
            case 7:
              res = _context6.sent;
              if (res.data.code === 100) {
                this.recommendList = [].concat(_toConsumableArray(this.recommendList), _toConsumableArray((_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.data) === null || _res$data === void 0 ? void 0 : _res$data.list));
                this.totalPages = (_res$data$data4 = res.data.data) === null || _res$data$data4 === void 0 ? void 0 : _res$data$data4.lastPage;
                this.disabled = this.pageNo > this.totalPages - 1;
                this.status = false;
              } else {
                this.$message.error(res.data.message);
              }
              this.loading = false;
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getProductList() {
        return _getProductList2.apply(this, arguments);
      }
      return getProductList;
    }()
  }]);
}(Vue);
__decorate([State('equipment')], default_1.prototype, "printerModelInfor", void 0);
__decorate([Action('card/setCardNum')], default_1.prototype, "setCardNum", void 0);
__decorate([Action('white/setWhiteStauts')], default_1.prototype, "setWhiteStauts", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isFixed", void 0);
__decorate([Watch('printerModelInfor', {
  deep: true
})], default_1.prototype, "onPrinterModelChange", null);
default_1 = __decorate([Component({
  components: {
    Price: Price,
    SKU: SKU
  }
})], default_1);
export default default_1;